<template>
  <div class="relative">
    <p class="relative__title">{{ relativeAlbumTitle }}</p>

    <ul class="relative-list">
      <li class="relative-list__item GTM_POINT_albims-info" v-for="item of relatedAlbumList" :key="item.label">
        <router-link class="link-box" :to="{
      name: 'explore-albums-info',
      params: {
        id: item.albumUid,
      },
    }">
          <img class="relative-list__item__img" :src="imageSource(item.artworkInfo)" />
          <tooltip :label="item.albumTitleDisplay" whiteSpaceNoWrap placement="left">
            <p class="relative-list__item__label">{{ item.albumTitleDisplay }}</p>
          </tooltip>
          <p class="relative-list__item__id">{{ item.albumCode }}</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, watch, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { searchAlbumRelatedAPI } from '@/api/getAlbums';
import useRequest from '@/hooks/useRequest';
import imageSource from '@/utils/imageSource';
import Tooltip from '@/components/Global/Tooltip.vue';

export default defineComponent({
  name: 'RelativedAblums',
  components: {
    Tooltip,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    albumUid: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t, locale } = useI18n();

    const relatedAlbumList = ref([]);
    const { request, response } = useRequest(searchAlbumRelatedAPI);

    const handleRequest = () => {
      const albumTags = (props.data.tags || []);

      const tagUidList = albumTags.length
        ? albumTags
          .filter((item) => item.tag)
          .map((item) => item.tag.tagUid)
        : [];

      request({
        in: {
          albumUid: props.data.albumUid,
          labelUid: props.data.publisherAndLabel[0]?.label.labelUid,
          tagsUid: tagUidList,
        },

      });
    };

    handleRequest();

    watch(response, () => {
      const [, res] = response.value;

      if (res) {
        relatedAlbumList.value = res.searchAlbumRelated;
      }
    });

    const mockData = [
      {
        label: 'Nordic Drama1',
        id: 'NORD122',
      },
      {
        label: 'Nordic Drama2',
        id: 'NORD122',
      },
      {
        label: 'Nordic Drama3',
        id: 'NORD122',
      },
      {
        label: 'Nordic Drama4',
        id: 'NORD122',
      },
    ];

    const convertType = {
      Albums: t('global.exploreType.albums'),
      Playlists: t('global.exploreType.playlists'),
    };

    const router = useRouter();

    const toAlbumsInfo = (id) => {
      router.push({
        name: 'explore-albums-info',
        params: {
          id,
        },
      });
    };

    watch(() => props.albumUid, () => {
      if (props.albumUid) {
        handleRequest();
      }
    });

    console.log('locale.value', locale.value);
    const relativeAlbumTitle = computed(() => {
      return `${t('explore.relative')}${locale.value === 'en' ? ' ' : ''}${convertType[props.type]}`;
    });

    return {
      mockData,
      toAlbumsInfo,
      convertType,
      relatedAlbumList,
      imageSource,
      relativeAlbumTitle,
    };
  },
});
</script>

<style lang="scss" scoped>
.relative {
  display: block;
  margin-top: 40px;

  &__title {
    @include font-style($c-black, 14, bold, 0.8px, 18px);
  }
}

.relative-list {
  @include flex();
  flex-wrap: wrap;
  margin: 12px -5px 0;

  &__item {
    flex: 50%;
    @include padding(0 8px);
    margin-top: 20px;
    cursor: pointer;

    &:first-child,
    &:nth-child(2) {
      margin-top: 0px;
    }

    &__img {
      width: 100%;
      border-radius: 5px;
    }

    &__label {
      @include word-ellipsis(1);
      @include font-style($c-black, 14, bold, 0.7px, 18px);
    }

    &__id {
      @include word-ellipsis(1);
      @include font-style($c-assist6, 14, 400, 0.7px, 18px);
    }
  }
}

.link-box {
  display: block;
}

@media screen and (min-width: $portrait) {
  .relative-list {
    &__item {
      flex: 25%;

      margin-top: 0px;
    }
  }
}

@media screen and (min-width: $sm-pc) {
  .relative-list {
    &__item {
      flex: 50%;
      margin-top: 20px;

      &:first-child,
      &:nth-child(2) {
        margin-top: 0px;
      }
    }
  }
}
</style>
